import { render } from "./MessagesChatComponent.vue?vue&type=template&id=29ad319a&scoped=true&ts=true"
import script from "./MessagesChatComponent.vue?vue&type=script&lang=ts"
export * from "./MessagesChatComponent.vue?vue&type=script&lang=ts"

import "./MessagesChatComponent.vue?vue&type=style&index=0&id=29ad319a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ad319a"]])

export default __exports__